import { useEffect } from 'react';
import { Outlet, useMatch, useNavigate } from 'react-router-dom';
import { IconLoader } from '@ui/src';
import { useAppSelector } from '@store';
import { useGetValidatorsQuery } from './store/services';

import ROUTES from '../routes';

import cn from './styles.module.css';

const Login = () => {
  const match = useMatch(ROUTES.LOGIN);
  const navigate = useNavigate();

  useGetValidatorsQuery();

  const { validatorsIsLoading } = useAppSelector((state) => state.auth);
  const { whitelabel } = useAppSelector((state) => state.root);

  useEffect(() => {
    let title = 'Ultimate core banking software';

    if (whitelabel) {
      title = `${whitelabel?.data?.value?.companyName}: ${title}`;

      localStorage.setItem('companyName', whitelabel?.data?.value?.companyName);
    }

    document.title = title;
  }, [whitelabel]);

  let content;

  if (validatorsIsLoading) {
    content = (
      <div className={cn.authPageLoader}>
        <IconLoader />
      </div>
    );
  } else {
    content = (
      <div className={cn.authPage}>
        <div className={cn.authPageContent}>
          <div className={cn.logo}>
            <div className={cn.logoImage}>
              <img src={whitelabel?.data?.value?.headerLogo} alt="Logo" />
            </div>

            <h2>Administration</h2>
          </div>
          <Outlet />
        </div>
      </div>
    );
  }

  useEffect(() => {
    if (match) {
      navigate(ROUTES.LOGIN_EMAIL);
    }
  }, [match]);

  return content;
};

export default Login;
